import { useState, useEffect } from 'react'
import {getFieldNameBuilder } from "../../util";

export const Periodicity = ({ state: [state, setState], frequencyTypes, fieldPrefix }) => {

  const getFieldName = getFieldNameBuilder(fieldPrefix);
  if( !state ) {
    const [state, setState] = useState({period: Object.keys(frequencyTypes).at(0), frequency: 1 } )
  }

  //const frequencyTypes = { 'yearly': 'Year', 'monthly': 'Month', 'weekly': 'Week' }
  const frequencyField = tangibleFields.render({
    type: 'select',
    name: getFieldName('period'),
    label: 'Frequency',
    choices: frequencyTypes,
    value: state.period
  })

  const frequencyUnitField = tangibleFields.render({
    type: 'number',
    name: getFieldName('frequency'),
    label: 'Every',
    minValue: 1,
    value: state.frequency
  })

  tangibleFields.event('valueChange', field => {
    if      ( field.name === getFieldName('period') ) setState({...state, period: field.value})
    else if ( field.name === getFieldName('frequency') ) setState({ ...state, frequency: field.value })
  })

  return (
    <div className="row">
      { frequencyField }
      { frequencyUnitField }
      <span className="tf-description">{frequencyTypes[state.period]}{ state.frequency > 1 && 's'}</span>
    </div>
  )
}
